import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'lang'
})
export class LangFormatPipe implements PipeTransform {

  transform(value: string, lang: string): string {
    if (!value) {
      return '';
    }
    
    if (!value.search || !lang)
      return value;

    //value = value.toString();
    var start = 0, end = value.length;
    var re1 = new RegExp('<'+lang+'>'), re2 = new RegExp('</'+lang+'>');
    
    start = value.search(re1) + 4;
    end = value.search(re2);
    if (start == 3)  //tag not found (start=-1+4)
      return '';
    else
      return value.slice(start, end);
  }

}
